import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-financial-statements',
  templateUrl: './financial-statements.component.html',
  styleUrls: ['./financial-statements.component.scss'],
})
export class FinancialStatementsComponent {
  constructor(
    private readonly toaster: ToastrService,
    private readonly translate: TranslateService
  ) {}

  showGlobalError() {
    this.toaster.error('', this.translate.instant('something-went-wrong'));
  }
}
